import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { UserDataService } from '@com-delta-idp/mnx-oauth';

declare let delta: any;

@Component({
  selector: 'ngc-mytrips-logged-in',
  templateUrl: 'mytrips-logged-in.component.html'
})
export class MytripsLoggedInComponent implements OnInit {
  @Input() tripDetails: any;
  @Input() tripContent: any;
  @Input() iropAemMessage: string;
  @Input() isCityNameOnly: boolean;
  public todaysTripForm: any;
  public confirmationNo: any;
  public lastName: any;
  public firstName: any;
  public formActionFlight = '/mytrips/findPnr.action';
  @ViewChild('flyoutTodayMytripsForm') flyoutTodayMytripsForm: ElementRef;

  constructor(private userData: UserDataService) {
    this.confirmationNo = '';
    this.lastName = '';
    this.firstName = '';
  }

  ngOnInit() {
    if (this.tripDetails !== undefined && this.tripDetails !== null) {
      if (
        this.tripDetails.flightTripDetails !== undefined &&
        this.tripDetails.flightTripDetails !== null &&
        this.tripDetails.flightTripDetails.detailsLink !== undefined &&
        this.tripDetails.flightTripDetails.detailsLink !== null
      ) {
        this.confirmationNo = this.tripDetails.flightTripDetails.detailsLink
          .split('?')[1]
          .split('&')[0]
          .split('=')[1];
        this.lastName = this.tripDetails.flightTripDetails.detailsLink
          .split('?')[1]
          .split('&')[1]
          .split('=')[1];
        this.firstName = this.tripDetails.flightTripDetails.detailsLink
          .split('?')[1]
          .split('&')[2]
          .split('=')[1];
      }
      if (
        this.tripDetails.vacationTripDetails !== undefined &&
        this.tripDetails.vacationTripDetails !== null &&
        this.tripDetails.vacationTripDetails.detailsLink !== undefined &&
        this.tripDetails.vacationTripDetails.detailsLink !== null
      ) {
        this.confirmationNo = this.tripDetails.vacationTripDetails.detailsLink
          .split('?')[1]
          .split('&')[0]
          .split('=')[1];
        this.lastName = this.tripDetails.vacationTripDetails.detailsLink
          .split('?')[1]
          .split('&')[1]
          .split('=')[1];
        this.firstName = this.tripDetails.vacationTripDetails.detailsLink
          .split('?')[1]
          .split('&')[2]
          .split('=')[1];
      }
      if (
        this.tripDetails.carTripDetails !== undefined &&
        this.tripDetails.carTripDetails !== null &&
        this.tripDetails.carTripDetails.detailsLink !== undefined &&
        this.tripDetails.carTripDetails.detailsLink !== null
      ) {
        this.confirmationNo = this.tripDetails.carTripDetails.detailsLink
          .split('?')[1]
          .split('&')[0]
          .split('=')[1];
        this.lastName = this.tripDetails.carTripDetails.detailsLink
          .split('?')[1]
          .split('&')[1]
          .split('=')[1];
        this.firstName = this.tripDetails.carTripDetails.detailsLink
          .split('?')[1]
          .split('&')[2]
          .split('=')[1];
      }
    }
  }

  mytripsTodayClick(e: any): void {
    this.userData.getAuthConfigContent().subscribe((response) => {
      if (response?.NEXT_GEN_MY_TRIPS) {
        if (this.confirmationNo && this.firstName && this.lastName) {
          sessionStorage.setItem(
            'trip_request',
            JSON.stringify({
              recordLocator: this.confirmationNo,
              firstName: this.firstName,
              lastName: this.lastName,
              searchType: 'confirmationNo'
            })
          );
          window.location.href = response?.NEXT_GEN_MY_TRIPS_URL
            ? response.NEXT_GEN_MY_TRIPS_URL
            : '/my-trips/trip-details';
        } else {
          window.location.href = response?.NEXT_GEN_MY_TRIPS_URL
            ? response.NEXT_GEN_MY_TRIPS_URL
            : '/my-trips/trip-details';
        }
      } else {
        if (
          this.flyoutTodayMytripsForm !== undefined &&
          this.flyoutTodayMytripsForm !== null
        ) {
          this.flyoutTodayMytripsForm.nativeElement.action =
            this.formActionFlight;
          this.flyoutTodayMytripsForm.nativeElement.submit();
        }
      }
    });
  }
}
